export default __webpack_public_path__ + "static/media/total_icon.33f089e8.svg";